import React from 'react'

const Footer = () => {
    return (
        <>
            <footer>
                fsdag

            </footer>
        </>
    )
}

export default Footer
